module.exports = __webpack_public_path__ + "static/Maytronics_GREY-d83e6530325335f20b0c9e5b8bb6f0b9.svg";